import './style/index.less';
import DialogForMobile from './DialogForMobile';

export default DialogForMobile;
